
<ckeditor [editor]="Editor" [config]="config" (ready)="onReady($event)"  [data]="dataPrivate" (change)="onChange($event)"></ckeditor>